<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <q-toolbar>
          <q-toolbar-title>Tecnologías sin zanja</q-toolbar-title>
          <div class="logo">
            <a href="https://www.veolia.es/hubgrade" target="_blank">
              <img src="@/assets/img/panel/hubgrade-blanco.svg" />
            </a>
          </div>
          <pre></pre>
          <pre></pre>
          <pre></pre>
          <pre></pre>
          <q-btn flat round dense icon="account_circle" to="logout" />
        </q-toolbar>
      </q-header>
    </q-layout>
  </div>
</template>
<script>
import '@/components/Usuarios/assets/css/css_usuario_vue.css';

import {
  QTabs,
  QCard,
  QRouteTab,
  QLayout,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
  QMenu,
  QDialog
} from 'quasar';

export default {
  data: function () {
    return {
      Datos_Registro: {
        mail: '',
        token: ''
      },

      mensaje: '',
      mostrar_mensaje: false,
      ok: false
    };
  },

  mounted () {
    this.mensaje = '';
    this.mostrar_mensaje = false;
    this.validacion();
  },

  components: {
    QTabs,
    QRouteTab,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QMenu,
    QTabs,
    QDialog
  },

  methods: {
    mostrar_mensajes (mensaje, color = 'red', timeout = 10000) {
      this.showError(mensaje, color, timeout);
    },

    comprobar_accion () {
      if (this.ok) {
        this.$router.push({ name: 'login' });
      }
    },

    validacion () {
      this.Datos_Registro.mail = this.$route.query.mail;
      this.Datos_Registro.token = this.$route.query.token.replace(/ /g, '+');
      this.$store.commit('TSZ/setDatosRegistroUsuario', this.Datos_Registro);
      this.$store
        .dispatch('TSZ/postDatosRegistrarUsuario')
        .then((response) => {
          this.ok = true;
          this.mostrar_mensajes('Usuario registrado correctamente', 'green');
          this.$router.push({ name: 'login' });
        })
        .catch((err) => {
          this.mostrar_mensajes(err.response.data);
        });
      // Redirigir a la página de login una vez validado...
      // this.$router.push({name:'login'});
      // this.mostrar_mensaje('Usuario registrado correctamente');

      //
    },
    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        multiLine: true,
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [
          {
            label: 'ACEPTAR',
            color: 'white',
            handler: () => {
              this.comprobar_accion();
            }
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  img {
    margin-top: 10px;
    max-width: 135px;
    padding: 0px 0 0 0;
    height: 40px;
    align-items: center;
  }
  i {
    padding: 18px 2% 0 5%;
  }
}
</style>
